import type {ClientId, ClientProfile} from './types';
import {isClientId} from './types';
import {identityProfile} from './profiles/identity';
import {goProfile} from './profiles/go';
import {salamProfile} from './profiles/salam';

const PROFILES: Record<ClientId, ClientProfile> = {
  identity: identityProfile,
  go: goProfile,
  salam: salamProfile
};

/**
 * Resolve ClientProfile by ClientId. Defaults to identity when missing or invalid.
 */
export function getClientProfile (clientId: string | undefined): ClientProfile {
  return isClientId(clientId) ? PROFILES[clientId] : PROFILES.identity;
}
